
import { BaseView } from "@/services/BaseView";
import { DataClient } from "@/services/DataClient";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class extends BaseView {
    showLanguageSelector = true;

    targetElevation = 0;
    targetBackgroundColor = "transparent";

    @Prop({ required: true, type: String })
    language!: string;

    toggleSidebar() {
        this.$emit("toggleSidebar");
    }

    get isMobile() {
        return this.$vuetify.breakpoint.smAndDown;
    }

    languages = [
        {
            title: "Español",
            code: "es",
        },
        {
            title: "English",
            code: "en",
        },
        {
            title: "Deutsch",
            code: "de",
        },
        {
            title: "Français",
            code: "fr",
        },
        {
            title: "Italiano",
            code: "it",
        },
    ];

    async mounted() {
        if (this.fullHeight) {
            window.removeEventListener("scroll", () => this.changeColor());
            window.addEventListener("scroll", () => this.changeColor());
        }
    }

    get fullHeight(): boolean {
        return DataClient.instance.configuration.fullScreenCarrousel;
    }

    get elevation(): number {
        return this.fullHeight ? this.targetElevation : 3;
    }

    get backgroundColor(): string {
        return this.fullHeight ? this.targetBackgroundColor : "white";
    }

    get languageName() {
        // get language name from code
        const language = this.languages.find((item) => item.code === this.$i18n.locale);
        if (language) {
            return language.title;
        }

        // fallback to code
        return this.$i18n.locale;
    }

    setLanguage(code: string) {
        this.$emit("languageChanged", code);
    }

    changeColor() {
        let elevation = 0;
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        if (scrollTop >= 0 && scrollTop < 33) {
            elevation = 0;
        } else if (scrollTop >= 33 && scrollTop < 66) {
            elevation = 1;
        } else if (scrollTop >= 66 && scrollTop < 100) {
            elevation = 2;
        } else if (scrollTop >= 100) {
            elevation = 3;
        }

        if (elevation > 0) {
            this.targetBackgroundColor = "white";
            this.targetElevation = elevation;
        } else {
            this.targetBackgroundColor = "transparent";
            this.targetElevation = 0;
        }
    }
}
